import { z } from "zod";
import { SocialPostType } from "../../types/models/campaign.models.types";
import { SocialCreatorType } from "../../types/models/social.models.types";

function transformEmptyString(x: string) {
  return x.trim().length === 0 ? undefined : x;
}

export const zProposalFormAdmin = z.object({
  brand: z.string().min(1, { message: "Brand is required" }),
  socialCreatorType: z.nativeEnum(SocialCreatorType),
  socialPostType: z.nativeEnum(SocialPostType),
  name: z.string().min(1, { message: "Campaign name is required" }),
  brief: z.string().min(1, { message: "Campaign brief is required" }),
  expectedMetrics: z
    .object({
      cost: z.coerce.number().min(1, { message: "Cost is required" }),
      views: z.coerce.number().min(1, { message: "Views is required" }),
      posts: z.coerce.number().min(1, { message: "Posts is required" }),
    })
    .optional(),

  referenceCreators: z
    .array(
      z.object({
        url: z.string().url({ message: "Invalid URL" }),
      })
    )
    .default([]), // .optional(),
  notes: z.string().transform(transformEmptyString).optional(),
});

export type IzSampleFormAdmin = z.infer<typeof zProposalFormAdmin>;
